@if (service.shouldShowPrompt()) {
  <div
    class="tw:fixed tw:bottom-0 tw:left-0 tw:bg-white tw:p-8 tw:w-full tw:border-t tw:border-gray-300 tw:rounded-lg tw:shadow-2xl tw:flex tw:flex-col tw:gap-4 tw:z-[9999]"
    role="dialog"
    aria-modal="true"
    aria-labelledby="pwa-install-title"
    aria-describedby="pwa-install-desc"
    tabindex="-1"
    (keydown.escape)="dismiss()"
    @slideFade
  >
    <div class="tw:flex tw:flex-col tw:gap-2 tw:max-w-100 tw:mx-auto tw:w-full">
      <button
        class="tw:absolute tw:top-3 tw:right-3 tw:bg-transparent tw:border-0 tw:text-2xl tw:leading-none tw:cursor-pointer"
        [attr.aria-label]="'pwa.dismiss_btn' | translate"
        (click)="dismiss()"
      >
        &times;
      </button>

      <h2 id="pwa-install-title" class="tw:text-xl tw:font-semibold tw:m-0!">
        {{ "pwa.title" | translate }}
      </h2>

      @if (service.isSafariLike()) {
        <p class="tw:m-0!">{{ "pwa.instructions.ios" | translate }}</p>
        <ul
          class="tw:list-disc tw:pl-4 tw:text-sm tw:list-decimal! tw:marker:text-gray-40! tw:marker:text-left! tw:marker:w-5!"
        >
          <li>{{ "pwa.instructions.ios-step-1" | translate }}</li>
          <li>{{ "pwa.instructions.ios-step-2" | translate }}</li>
          <li>{{ "pwa.instructions.ios-step-3" | translate }}</li>
        </ul>
      } @else {
        <p class="tw:m-0!">{{ "pwa.instructions.default" | translate }}</p>
      }

      <div class="tw:flex tw:flex-col tw:justify-end tw:gap-4 tw:mt-2">
        @if (!service.isSafariLike()) {
          <button cfButton (click)="prompt()">{{ "pwa.install_btn" | translate }}</button>
        }
        <button cfButton variant="ghost" class="tw:text-gray-40" (click)="dismiss()">
          {{ "pwa.dismiss_btn" | translate }}
        </button>
      </div>
    </div>
  </div>
}
